/* @flow */
import { ActionTypes as AppActions } from 'constants/AppConstants';
import { PushEvents } from 'pusher/PusherConstants';
import Store from 'lib/Store';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class ConnectionState extends Store {
  getInitialState() {
    return {
      connectionState: 'connected',
      pusherState: 'connected',
      hasRetriedConn: false,
    };
  }

  isConnected(): boolean {
    return this.state.connectionState === 'connected' && this.state.pusherState === 'connected';
  }

  isConnecting(): boolean {
    return this.state.connectionState === 'connecting' || this.state.pusherState === 'connecting';
  }

  getPusherState() {
    return this.state.pusherState;
  }

  hasRetriedConnection(): boolean {
    return this.state.hasRetriedConn;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case AppActions.CONNECTION_STATE_CHANGED:
        this.handleConnectionStateChanged(action.previous, action.current);
        break;
      case PushEvents.CONNECTION_STATE_CHANGED:
        this.handlePusherStateChanged(action.previous, action.current);
        break;
      case PushEvents.RETRY_CONNECTION:
        this.handleRetryConnection();
        break;
      case PushEvents.RESET_STORE:
        this.state = this.getInitialState();
        break;
      default:
        break;
    }
  }

  handleConnectionStateChanged(previous, current): void {
    this.state.connectionState = current;
    if (current === 'connected') {
      this.emit('reconnect');
      this.state.hasRetriedConn = false;
    }
    this.emitChange();
  }

  handlePusherStateChanged(previous, current): void {
    this.state.pusherState = current;
    if (current === 'connected') {
      this.emit('reconnect');
      this.state.hasRetriedConn = false;
    }
    this.emitChange();
  }

  handleRetryConnection(): void {
    this.state.hasRetriedConn = true;
    this.emitChange();
  }
}

export default new ConnectionState();
